<app-header />
<p-toast></p-toast>
<div class="contact">
  <div class="contact_top text-center">
    <ng-container *ngFor="let heading of head">
      <div
        class="bg_6 inline_padding2 contact_top_box"
        *ngIf="heading.page === currentPage"
      >
        <div class="contact_top_box_inner">
          <div class="inline_padding3">
            <span class="text_style_5">Contact Us</span>
          </div>
          <div class="inline_padding3 p-top-16">
            <span
              class="text_style_1"
              [innerHTML]="heading.page_sub_heading"
            ></span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="contact_bottom bg_6 p-x-100-res-1">
    <div class="contact_bottom_cols border-radius-35 bg_1">
      <div class="contact_bottom_cols_left p-20">
        <div>
          <div>
            <span class="text_white_5">Contact Information</span>
          </div>
          <div class="p-top-20">
            <span class="text_white_4"
              >Ready to put yourself in Expert Hands?</span
            >
          </div>
        </div>
        <div class="contact_bottom_cols_left_mid">
          <div class="contact_bottom_cols_left_mid_item1">
            <div class="contact_bottom_cols_left_mid_item1_box dis-flex-3">
              <img
                width="25.97px"
                src="../../../assets/icons/leaves_icon.png"
              />
              <div class="text_white_19 p-top-8">AgroPat</div>
            </div>
          </div>
          <div class="contact_bottom_cols_left_mid_item2">
            <div class="contact_bottom_cols_left_mid_item2_box dis-flex-3">
              <img width="25.97px" src="../../../assets/icons/pills_icon.png" />
              <div class="text_white_19 p-top-8">Pharma</div>
            </div>
          </div>
          <div class="contact_bottom_cols_left_mid_item3">
            <div class="contact_bottom_cols_left_mid_item3_box dis-flex-3">
              <img
                width="25.97px"
                src="../../../assets/icons/laboratory_icon.png"
              />
              <div class="text_white_19 p-top-8">Chemical</div>
            </div>
          </div>
        </div>
        <div class="contact_bottom_cols_left_conatiner_botm dis-block-1">
          <div class="dis-flex-4 p-x-5 p-top-10">
            <div>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.6873 6.71429C13.7065 4.45849 11.7853 2.39052 9.40448 2.10456C9.35713 2.09894 9.30555 2.09039 9.25094 2.08135C9.13308 2.06182 9.01119 2.04175 8.88821 2.04175C8.40026 2.04175 8.26983 2.38451 8.23549 2.58893C8.2021 2.78769 8.23395 2.95459 8.33 3.08523C8.49159 3.30495 8.77591 3.34396 9.00429 3.37521C9.07122 3.38446 9.13437 3.39305 9.18724 3.40493C11.3263 3.88289 12.0465 4.63434 12.3985 6.75519C12.4071 6.80702 12.411 6.87087 12.4151 6.93859C12.4305 7.19211 12.4625 7.71956 13.0295 7.71956H13.0296C13.0768 7.71956 13.1275 7.71549 13.1803 7.70744C13.7084 7.62719 13.6918 7.14505 13.6839 6.9134C13.6817 6.84816 13.6795 6.78644 13.685 6.7454C13.6865 6.73506 13.6873 6.72468 13.6873 6.71429Z"
                  fill="white"
                />
                <path
                  d="M8.74968 1.27642C8.81304 1.28099 8.87301 1.28537 8.92295 1.29302C12.4354 1.83319 14.0508 3.49739 14.4985 7.03737C14.5061 7.09754 14.5072 7.17093 14.5085 7.24865C14.513 7.52522 14.5222 8.10057 15.14 8.1125L15.1592 8.1127C15.353 8.1127 15.5071 8.05426 15.6174 7.93888C15.8098 7.73769 15.7963 7.43881 15.7855 7.19861C15.7829 7.13968 15.7803 7.08417 15.781 7.03558C15.8257 3.41511 12.6917 0.132075 9.0745 0.00998758C9.0595 0.00949068 9.04518 0.0102857 9.03073 0.012323C9.02362 0.0133665 9.01045 0.0146584 8.98789 0.0146584C8.95182 0.0146584 8.90745 0.0115279 8.86039 0.00834783C8.80349 0.00447205 8.739 0 8.67361 0C8.09756 0 7.98804 0.409441 7.97403 0.653516C7.94173 1.21759 8.48742 1.25729 8.74968 1.27642Z"
                  fill="white"
                />
                <path
                  d="M14.3288 11.6127C14.2541 11.5556 14.1769 11.4966 14.1046 11.4384C13.7211 11.1297 13.3131 10.8453 12.9185 10.5701C12.8366 10.5131 12.7547 10.456 12.6731 10.3988C12.1677 10.0437 11.7133 9.8712 11.284 9.8712C10.7057 9.8712 10.2016 10.1907 9.78547 10.8207C9.60112 11.1 9.37747 11.2358 9.10184 11.2358C8.93886 11.2358 8.75367 11.1893 8.55148 11.0975C6.92003 10.3577 5.75506 9.2234 5.08887 7.72611C4.76684 7.00243 4.87123 6.52939 5.43799 6.14439C5.75983 5.92596 6.35889 5.5193 6.31645 4.74057C6.2684 3.85624 4.3172 1.19542 3.49509 0.893213C3.14701 0.765213 2.7813 0.76402 2.40614 0.890232C1.46105 1.20795 0.782837 1.76591 0.444651 2.5037C0.117843 3.21659 0.132601 4.05366 0.487334 4.92442C1.51282 7.44198 2.95461 9.63696 4.7728 11.4483C6.55248 13.2214 8.73986 14.6738 11.2741 15.7651C11.5025 15.8633 11.7421 15.917 11.9171 15.9561C11.9767 15.9695 12.0282 15.9809 12.0657 15.9912C12.0863 15.9968 12.1076 15.9998 12.1289 16L12.1489 16.0001C12.1489 16.0001 12.1489 16.0001 12.149 16.0001C13.341 16.0001 14.7722 14.911 15.2118 13.6692C15.5968 12.5819 14.8937 12.0445 14.3288 11.6127Z"
                  fill="white"
                />
                <path
                  d="M9.27665 4.15229C9.07257 4.15746 8.64788 4.16799 8.49886 4.60054C8.42915 4.80268 8.43749 4.97818 8.52371 5.12218C8.65021 5.33346 8.8926 5.3982 9.11307 5.43373C9.91262 5.56203 10.3233 6.00417 10.4054 6.82504C10.4436 7.20779 10.7013 7.47507 11.0322 7.47507C11.0567 7.47507 11.0817 7.47363 11.1066 7.4706C11.5046 7.42325 11.6976 7.13082 11.6801 6.60153C11.6865 6.04913 11.3974 5.422 10.9057 4.92248C10.4124 4.42141 9.81762 4.13922 9.27665 4.15229Z"
                  fill="white"
                />
              </svg>
            </div>
            <div class="p-l-10 dis-flex-8 flex-wrap">
              <div class="right-border-2 p-r-5">
                <span class="text_white_4">+91-626 611 7944</span>
              </div>
              <div class="p-l-5">
                <span class="text_white_4">+91-940 736 0810</span>
              </div>
            </div>
          </div>
          <div class="dis-flex-4 p-top-10">
            <div>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_3142_10676)">
                  <path
                    d="M8.17001 8.57754C7.82171 8.80974 7.41713 8.93249 7 8.93249C6.5829 8.93249 6.17832 8.80974 5.83002 8.57754L0.0932148 4.75289C0.0613867 4.73167 0.0303789 4.70955 0 4.6868V10.9539C0 11.6724 0.583105 12.2427 1.28879 12.2427H12.7112C13.4297 12.2427 14 11.6596 14 10.9539V4.68677C13.9695 4.70957 13.9385 4.73175 13.9066 4.75299L8.17001 8.57754Z"
                    fill="white"
                  />
                  <path
                    d="M0.548242 4.07039L6.28504 7.89507C6.50221 8.03985 6.75109 8.11223 6.99997 8.11223C7.24888 8.11223 7.49779 8.03982 7.71496 7.89507L13.4518 4.07039C13.7951 3.84166 14 3.45884 14 3.04568C14 2.33526 13.422 1.75732 12.7116 1.75732H1.28836C0.577965 1.75735 0 2.33529 0 3.04636C0 3.45884 0.204969 3.84166 0.548242 4.07039Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3142_10676">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="p-l-10 dis-flex-8 flex-wrap">
              <div class="right-border-2 p-r-5">
                <span class="text_white_4 text-wrap"
                  >support&commat;chemrobotics.com</span
                >
              </div>
              <div class="p-l-5">
                >
                <span class="text_white_4 text-wrap"
                  >sales&commat;chemrobotics.com</span
                >
              </div>
            </div>
          </div>
          <div class="dis-flex-4 p-top-10">
            <div>
              <svg
                width="12"
                height="16"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_3142_5929)">
                  <path
                    d="M6 0C2.68811 0.00439329 0.0043933 2.68811 0 6C0 10.3075 5.59 15.7025 5.8275 15.93C5.92355 16.0233 6.07645 16.0233 6.1725 15.93C6.41 15.7025 12 10.3075 12 6C11.9956 2.68811 9.31189 0.00439329 6 0ZM6 8.75C4.48122 8.75 3.25 7.51877 3.25 5.99999C3.25 4.48121 4.48122 3.25 6 3.25C7.51878 3.25 8.75 4.48121 8.75 5.99999C8.74909 7.5184 7.51841 8.74908 6 8.75Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3142_5929">
                    <rect width="12" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="p-l-10">
              <span class="text_white_4"
                >ChemRobotics® Private Limited SITE C UPSIDC Surajpur, Greater
                Noida 201311, India</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="contact_bottom_cols_right bg_1">
        <div
          *ngIf="alertVisible"
          class="alert alert-success alert-dismissible fade show"
          role="alert"
        >
          <strong>Success!</strong> Your form has been submitted successfully.
          <button
            type="button"
            class="btn-close"
            (click)="closeAlert()"
          ></button>
        </div>

        <form [formGroup]="contactUsForm" (ngSubmit)="submit_contactus_form()">
          <div class="dis-grid-2 text_align contact_bottom_cols_right_name">
            <div class="p-10">
              <label class="text_grey_2">Name</label>
              <input
                type="text"
                id="name"
                formControlName="name"
                class="text_grey_1 height-50 border-radius-4 width-100-per p-x-15"
                placeholder="James"
              />
              <div
                *ngIf="formSubmitted && contactUsForm.controls['name'].invalid"
              >
                <small class="text-red-1">Name is required.</small>
              </div>
            </div>

            <div class="p-10 dis-block-1">
              <label class="text_grey_2">Phone</label>
              <div class="width-100-per">
                <select
                  id="countryCode1"
                  formControlName="country_code"
                  class="text_grey_1 height-50 border-radius-4 width-25-per"
                >
                  <option
                    *ngFor="let country of countries"
                    [value]="country.code"
                  >
                    {{ country.code }}
                    <!-- Only display the code, since img tag cannot be used within an <option> -->
                  </option>
                </select>
                <input
                  type="tel"
                  id="phone"
                  formControlName="number"
                  class="text_grey_1 height-50 border-radius-4 width-75-per p-x-15"
                  placeholder="932 791 6546"
                />
              </div>
              <div
                *ngIf="formSubmitted && contactUsForm.controls['phone'].invalid"
              >
                <small
                  *ngIf="contactUsForm.controls['phone'].errors?.['required']"
                  class="text-red-1"
                  >Phone number is required.</small
                >
                <small
                  *ngIf="contactUsForm.controls['phone'].errors?.['pattern']"
                  class="text-red-1"
                  >Phone number must be 10 digits.</small
                >
              </div>
            </div>
          </div>

          <div class="p-10 dis-block-1">
            <div class="width-100-per d-flex gap-2">
              <!-- Email Input -->
              <div class="width-50-per">
                <label class="text_grey_2">Email</label>
                <input
                  type="email"
                  id="email1"
                  formControlName="email"
                  class="text_grey_1 border-radius-4 height-50 width-100-per p-x-15"
                  placeholder="james.1978@gmail.com"
                />
                <div
                  *ngIf="
                    formSubmitted && contactUsForm.controls['email'].invalid
                  "
                >
                  <small
                    *ngIf="contactUsForm.controls['email'].errors?.['required']"
                    class="text-red-1"
                    >Email is required.</small
                  >
                  <small
                    *ngIf="contactUsForm.controls['email'].errors?.['email']"
                    class="text-red-1"
                    >Invalid email format.</small
                  >
                </div>
              </div>

              <!-- Subject Input -->
              <div class="width-50-per">
                <label class="text_grey_2">Subject</label>
                <input
                  type="text"
                  id="subject"
                  formControlName="subject"
                  class="text_grey_1 border-radius-4 height-50 width-100-per p-x-15"
                  placeholder="Write Subject......"
                />
                <div
                  *ngIf="
                    formSubmitted && contactUsForm.controls['subject'].invalid
                  "
                >
                  <small class="text-red-1">Subject is required.</small>
                </div>
              </div>
            </div>
          </div>

          <div class="text_align p-2">
            <label class="text_grey_2">Message</label>
            <textarea
              id="message"
              formControlName="message"
              class="text_grey_1 border-radius-4 p-x-20 width-100-per p-x-15"
              placeholder="Write message....."
              rows="4"
            ></textarea>
            <div
              *ngIf="formSubmitted && contactUsForm.controls['message'].invalid"
            >
              <small class="text-red-1">Message is required.</small>
            </div>
          </div>
          <div class="text_align p-2">
            <re-captcha
              class="m-t-20"
              [siteKey]="recaptchaSiteKey"
              (resolved)="onCaptchaSuccess($event)"
            >
            </re-captcha>
            <div *ngIf="formSubmitted && !recaptchaResponse">
              <small class="text-red-1">Please complete the reCAPTCHA.</small>
            </div>
          </div>

          <div>
            <button
              type="submit"
              class="rounded-pill text_white_1 button_blue_1 m-t-20 dis-block-1"
            >
              <span class="button_blue_1_text">Send Message</span>
              <img
                class="button_blue_1_text_icon"
                src="../../../assets/icons/arrow-right.png"
              />
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="bg_2 p-top-50 m-t-25-neg"></div>
</div>
<div class="google-map" style="background-color: #fafbff; margin-bottom: 40px">
      <div class="business-map-section">
        <div class="business-details">
          <h2>
            ChemRobotics™ Business, Scientific, & Innovation Intelligence for
            Agrochem, Pharmachem API & Specialty Chem Industry
          </h2>
          <p class="category">ChemRobotics Private Limited</p>
          <p class="category">Database Management Company</p>
          <!-- <div class="rating">⭐ 5.0 <span>(24)</span></div> -->
          <hr />
          <div class="button-section">
            <!-- Directions -->
            <a href="https://maps.app.goo.gl/zN6xURYsdRkMqFPP8" target="_blank" rel="noopener noreferrer">
              <button>
                <i class="icon fa fa-map-marker-alt"></i>
                Direction
              </button>
            </a>

            <!-- Share -->
            <a href="https://wa.me/?text=https://maps.app.goo.gl/zN6xURYsdRkMqFPP8" target="_blank"
              rel="noopener noreferrer">
              <button>
                <i class="icon fa fa-share-alt"></i>
                Share
              </button>
            </a>

            <!-- Copy Link -->
            <button (click)="copyMapLink1()">
              <i class="icon fa fa-copy"></i>
              Copy Link
            </button>
          </div>

          <hr />
          <div class="address">
            <p>
              <i class="fa fa-map-marker-alt"></i> Mewar Industrial Area, S102, Rd Number 12, Madri, Transport Nagar,
              Udaipur, Rajasthan 313003
            </p>
            <!-- <p><i class="fa fa-clock"></i> <strong>Open</strong> · Closes 5 pm</p> -->
            <p>
              <i class="fa fa-globe"></i>
              <a href="https://chemrobotics.com" target="_blank">chemrobotics.com</a>
            </p>
            <p><i class="fa fa-phone"></i> 06266117944</p>
            <p><i class="fa fa-plus"></i>JMCW+FV Udaipur, Rajasthan</p>
            <p><i class="fa fa-heart"></i>Identifies as women-owned</p>
          </div>
        </div>

        <div class="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3628.2244064499814!2d73.74704009999999!3d24.581450500000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3967e57a5bd7a4bf%3A0x7af5859dddf571f!2sChemRobotics%20Private%20Limited!5e0!3m2!1sen!2sin!4v1779346430401!5m2!1sen!2sin"
            width="100%" height="100%" style="border: 0" allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </div>

<div class="google-map" style="background-color: #fafbff; margin-bottom: 40px">
  <div class="business-map-section">
    <div class="business-details">
      <h2>
        ChemRobotics™ Business, Scientific, & Innovation Intelligence for
        Agrochem, Pharmachem API & Specialty Chem Industry
      </h2>
      <p class="category">ChemRobotics Private Limited</p>
      <p class="category">Database Management Company</p>
      <!-- <div class="rating">⭐ 5.0 <span>(24)</span></div> -->
      <hr />
      <div class="button-section">
        <!-- Directions -->
        <a href="https://maps.app.goo.gl/FQf6fJJt42hpY7KM8" target="_blank" rel="noopener noreferrer">
          <button>
            <i class="icon fa fa-map-marker-alt"></i>
            Direction
          </button>
        </a>

        <!-- Share -->
        <a href="https://wa.me/?text=https://maps.app.goo.gl/FQf6fJJt42hpY7KM8" target="_blank"
          rel="noopener noreferrer">
          <button>
            <i class="icon fa fa-share-alt"></i>
            Share
          </button>
        </a>

        <!-- Copy Link -->
        <button (click)="copyMapLink()">
          <i class="icon fa fa-copy"></i>
          Copy Link
        </button>
      </div>

      <hr />
      <div class="address">
        <p>
          <i class="fa fa-map-marker-alt"></i> Silver Spring Apartment,
          ChemRobotics Unit-II, 102D, New Navratan Rd, Bhuwana, Udaipur,
          Rajasthan 313001
        </p>
        <!-- <p><i class="fa fa-clock"></i> <strong>Open</strong> · Closes 5 pm</p> -->
        <p>
          <i class="fa fa-globe"></i>
          <a href="https://chemrobotics.com" target="_blank">chemrobotics.com</a>
        </p>
        <p><i class="fa fa-phone"></i> 06266117944</p>
        <p><i class="fa fa-plus"></i>JMCW+FV Udaipur, Rajasthan</p>
        <p><i class="fa fa-heart"></i>Identifies as women-owned</p>
      </div>
    </div>

    <div class="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3664.8899426453776!2d73.6972985!3d24.6213051!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ceaf95d88dd13%3A0x4e8881e731f529bb!2sChemRobotics+Business,+Scientific,+%26+Innovation+Intelligence+for+Agrochem,+Pharmachem+API+%26+Specialty+Chem+Industry!5e0!3m2!1sen!2sin!4v1715581317487!5m2!1sen!2sin"
        width="100%" height="100%" style="border: 0" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
    </div>
  </div>
</div>

<app-footer />
